<template>
  <div
    class="modal fade"
    id="kt_modal_edit_contact"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-medium p-9">
      <div class="modal-content modal-rounded">
        <div class="modal-header py-7 d-flex justify-content-between">
          <h2 class="m-0">Edit contact</h2>
          <div
            id="dismiss-modal"
            class="btn btn-sm btn-icon btn-active-color-primary"
            data-bs-dismiss="modal"
            ref="closeModal"
          >
            <i class="ki-solid ki-cross fs-1"></i>
          </div>
        </div>
        <div class="modal-body scroll-y m-5">
            
            <div class="mb-10">
                <label for="name" class="required form-label">Name</label>
                <div class="position-relative">
                    <span class="text-danger" v-if="v$.editContactForm.name.$error">Please enter a contact name</span>
                    <input v-model="editContactForm.name" type="text" id="name" class="form-control" placeholder="">
                </div>
            </div>
            <div class="mb-10">
                <label for="phone" class="required form-label">Phone number</label>
                <div class="position-relative">
                    <span class="text-danger" v-if="v$.editContactForm.phoneNumber.$error">Please enter a phone number</span>
                    <input v-model="editContactForm.phoneNumber" type="tel" id="phone" class="form-control" placeholder="">
                </div>
            </div>
            <div class="mb-10">
                <label for="email" class="required form-label">Email address</label>
                <div class="position-relative">
                    <span class="text-danger" v-if="v$.editContactForm.email.$error">Please enter a valid email address</span>
                    <input v-model="editContactForm.email" type="email" id="email" class="form-control" placeholder="">
                </div>
            </div>
            <div class="mb-10">
                <label for="revenue" class="form-label required">Contact type</label>
                <div class="position-relative">
                  <span class="text-danger" v-if="v$.editContactForm.contactType.$error">Please select a contact type</span>
                  <select v-model="editContactForm.contactType" id="contactType" name="contactType" class="form-select">
                    <option v-for="(type, index) in contactTypes" :key="index" :value="type.value">{{ type.label }}</option>
                  </select>
                </div>
            </div>
            <button class="btn btn-primary me-4" @click="submitForm()">Update</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { required, email } from "@vuelidate/validators";
export default {
  name: 'EditContactToClient', 
  props: ['contact'],
  data() { 
    return {
      v$ : useVuelidate(),
      clientId: null,
      contactId: null,
      contactTypes: [],
      editContactForm: {
        name: '',
        phoneNumber: '',
        email: '',
        contactType: null
      }
    }
  },
  created() {
    this.initData();
  },
  validations() {
    return {
        editContactForm: {
            name: { required },
            phoneNumber: { required },
            email: { required, email },
            contactType: { required }
        }
    }
  },
  watch: {
    contact: function (newVal, oldVal) {
        if (newVal != oldVal) {
            this.contactId = this.contact.id;
            this.editContactForm.name = this.contact.name
            this.editContactForm.phoneNumber = this.contact.phoneNumber;
            this.editContactForm.email = this.contact.email;
            this.editContactForm.contactType = this.contact.contactType;
        }
    }
  },
  methods: {
    initData() {
      this.$api.getClientContactTypes().then((r) => {
        this.contactTypes = r.data;
      });
    },
    async submitForm() {
        await this.v$.$validate();
            if (!this.v$.editContactForm.$error) {
            this.$api.editClientContact(this.contactId, this.editContactForm).then(() => {
              this.$refs.closeModal.click();
              this.clearForm();
              this.$parent.initData();
            });
        }
    },
    async clearForm() {
      this.contactId = null;
      this.editContactForm.name = '';
      this.editContactForm.phoneNumber = '';
      this.editContactForm.email = '';
      this.editContactForm.contactType = null;
      this.v$.$reset();
    },
  }
};
</script>
